import { render, staticRenderFns } from "./ModalManageCompromise.vue?vue&type=template&id=3fa468f4"
import script from "./ModalManageCompromise.vue?vue&type=script&lang=js"
export * from "./ModalManageCompromise.vue?vue&type=script&lang=js"
import style0 from "./ModalManageCompromise.vue?vue&type=style&index=0&id=3fa468f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports